module.exports = __webpack_public_path__ + "media/talent/Moms-Libby-e7da4842.png";